import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { ComponentContainer } from 'golden-layout'

@Component({
  selector: 'hs-output-manager',
  templateUrl: './output-manager-panel.component.html',
  styleUrls: ['./output-manager-panel.component.scss'],
})
export class OutputManagerPanelComponent extends BasePanelComponent {
  constructor(@Inject(LayoutContainer) container: ComponentContainer) {
    super(container)
  }
  source = 'helios'
}
